module.exports = require("./mr.d.ts");